import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=4310f7cf&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=ts&"
export * from "./Overview.vue?vue&type=script&lang=ts&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=4310f7cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310f7cf",
  null
  
)

export default component.exports